var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlame = function SvgFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A5C",
    d: "M5.2.148a.834.834 0 0 0-1.133 1.119A6.8 6.8 0 0 1 4.092 7.4a.166.166 0 0 1-.291-.003 3.7 3.7 0 0 1-.374-1.046.503.503 0 0 0-.802-.291 5.77 5.77 0 0 0-1.854 6.4 5.205 5.205 0 0 0 5.166 3.49c2.819 0 4.79-1.43 5.41-3.922.92-3.678-1.336-9.33-6.147-11.88m3.158 11.919a2.21 2.21 0 0 1-2.339 1.886 2.27 2.27 0 0 1-2.236-1.874.333.333 0 0 1 .404-.384 2 2 0 0 0 1.667-.94 1.53 1.53 0 0 0 .302-1.64.333.333 0 0 1 .407-.475 3.15 3.15 0 0 1 1.795 3.427"
  })));
};
export default SvgFlame;